import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';
import { Button } from '../components/ui/Button';

export function AtendimentoPage() {
  const navigate = useNavigate();
  const usuario = useAuthStore((state) => state.usuario);
  const logout = useAuthStore((state) => state.logout);

  function handleLogout() {
    logout();
    navigate('/login', { replace: true });
  }

  return (
    <div className="min-h-screen flex flex-col bg-gray-900">
      {/* Header */}
      <header className="bg-gray-800 border-b border-gray-700 px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <h1 className="text-xl font-bold text-primary-400">Suporte Nexo</h1>
          <span className="text-xs text-gray-500">v0.1.0</span>
        </div>

        <div className="flex items-center gap-4">
          {usuario && (
            <div className="text-right">
              <div className="text-sm text-gray-100">{usuario.nome}</div>
              <div className="text-xs text-gray-500">
                {usuario.email} · {usuario.role}
              </div>
            </div>
          )}
          <Button variant="secondary" onClick={handleLogout}>
            Sair
          </Button>
        </div>
      </header>

      {/* Conteúdo placeholder */}
      <main className="flex-1 flex items-center justify-center p-8">
        <div className="card p-10 max-w-lg text-center">
          <div className="text-5xl mb-4">🚧</div>
          <h2 className="text-2xl font-semibold text-gray-100 mb-2">
            Atendimento em construção
          </h2>
          <p className="text-gray-400 mb-6">
            A tela principal de atendimento será implementada no <strong className="text-primary-400">Plano D</strong>.
          </p>
          <div className="text-left text-sm text-gray-500 space-y-1">
            <p>✅ Backend funcionando (porta 3004)</p>
            <p>✅ Login funcional (você está aqui!)</p>
            <p>✅ Autenticação JWT persistente</p>
            <p>⏳ Lista de tickets — Plano D</p>
            <p>⏳ Janela de chat — Plano D</p>
            <p>⏳ WebSocket real-time — Plano D</p>
          </div>
        </div>
      </main>
    </div>
  );
}
